{
  "blog": {
    "title": "Blog",
    "description": "Quản lý bài viết, phân loại và hashtag cho blog public của Printway. Lên lịch xuất bản theo giờ UTC; cron tự chuyển Bản nháp → Đã xuất bản khi tới giờ.",
    "tabsAriaLabel": "Tab blog",
    "tabs": {
      "posts": "Bài viết",
      "categories": "Phân loại",
      "hashtags": "Hashtag"
    },
    "columns": {
      "title": "Tiêu đề",
      "author": "Tác giả",
      "categories": "Phân loại",
      "published": "Ngày xuất bản",
      "scheduled": "Lên lịch",
      "updated": "Cập nhật"
    },
    "statusFilter": {
      "all": "Tất cả"
    },
    "statusLabels": {
      "draft": "Bản nháp",
      "scheduled": "Đã lên lịch",
      "published": "Đã xuất bản"
    },
    "posts": {
      "untitled": "(không có tiêu đề)",
      "statusFilterLabel": "Lọc trạng thái",
      "createLabel": "+ Tạo bài viết",
      "emptyState": "Chưa có bài viết — bấm + Tạo bài viết để tạo."
    }
  },
  "contact": {
    "title": "Liên hệ",
    "description": "Cấu hình biểu mẫu Liên hệ và quản lý phản hồi gửi từ trang công khai.",
    "tabsAriaLabel": "Tab",
    "tabs": {
      "config": "Cấu hình biểu mẫu",
      "submissions": "Phản hồi"
    },
    "fieldTypes": {
      "text": "Văn bản (1 dòng)",
      "multiline": "Nhiều dòng",
      "dropdown": "Danh sách thả xuống",
      "single_choice": "Chọn một",
      "multiple_choice": "Chọn nhiều"
    },
    "statusLabels": {
      "unread": "Chưa đọc",
      "read": "Đã đọc"
    },
    "toast": {
      "errorTitle": "Lỗi"
    },
    "config": {
      "loadError": "Không tải được cấu hình",
      "newFieldLabel": "Trường mới",
      "saveSuccess": "Đã lưu cấu hình biểu mẫu",
      "saveError": "Lưu thất bại",
      "formFieldsHeading": "Trường biểu mẫu",
      "addFieldButton": "+ Thêm trường",
      "loading": "Đang tải…",
      "emptyFields": "Chưa có trường nào. Bấm “Thêm trường” để bắt đầu.",
      "labelPlaceholder": "Nhãn hiển thị",
      "requiredLabel": "Bắt buộc",
      "placeholderPlaceholder": "Placeholder (tuỳ chọn)",
      "optionsLabel": "Tuỳ chọn (mỗi dòng một tuỳ chọn)",
      "removeFieldButton": "Xoá trường",
      "saving": "Đang lưu…",
      "saveButton": "Lưu cấu hình biểu mẫu"
    },
    "submissions": {
      "noNotificationBanner": "Lưu ý: hệ thống KHÔNG gửi thông báo khi có phản hồi mới. Admin cần vào trang này để kiểm tra định kỳ.",
      "loadError": "Không tải được phản hồi",
      "allStatuses": "Tất cả trạng thái",
      "searchPlaceholder": "Tìm theo tên / email",
      "searchButton": "Tìm",
      "loading": "Đang tải…",
      "empty": "Không có phản hồi nào phù hợp.",
      "columns": {
        "status": "Trạng thái",
        "name": "Tên",
        "email": "Email",
        "created": "Ngày tạo",
        "actions": "Hành động"
      },
      "viewButton": "Xem",
      "markReadError": "Cập nhật thất bại",
      "postNoteError": "Gửi ghi chú thất bại",
      "noteAdded": "Đã thêm ghi chú",
      "detailTitle": "Phản hồi từ {{name}}",
      "responsesHeading": "Câu trả lời",
      "noResponses": "Không có dữ liệu.",
      "adminNotesHeading_one": "Ghi chú admin ({{count}})",
      "adminNotesHeading_other": "Ghi chú admin ({{count}})",
      "noNotes": "Chưa có ghi chú.",
      "adminFallback": "admin",
      "notePlaceholder": "Thêm ghi chú phản hồi…",
      "posting": "Đang gửi…",
      "addNoteButton": "Thêm ghi chú",
      "closeButton": "Đóng"
    }
  },
  "ebooks": {
    "title": "Ebooks",
    "description": "Trang đích tải PDF (bố cục cố định).",
    "status": {
      "draft": "Bản nháp",
      "published": "Đã xuất bản",
      "archived": "Đã lưu trữ"
    },
    "actions": {
      "add": "Thêm ebook",
      "edit": "Sửa",
      "delete": "Xoá",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…"
    },
    "filters": {
      "allStatuses": "Tất cả trạng thái",
      "searchPlaceholder": "Tìm theo tên",
      "searchButton": "Tìm"
    },
    "list": {
      "loading": "Đang tải…",
      "empty": "Chưa có ebook nào."
    },
    "table": {
      "name": "Tên",
      "description": "Mô tả",
      "status": "Trạng thái",
      "created": "Ngày tạo",
      "creator": "Người tạo",
      "downloads": "Lượt tải",
      "url": "URL",
      "actions": "Hành động"
    },
    "dialog": {
      "addTitle": "Thêm ebook",
      "editTitle": "Sửa ebook"
    },
    "form": {
      "name": "Tên",
      "namePlaceholder": "Tiêu đề ebook",
      "slug": "Slug",
      "slugPlaceholder": "my-ebook",
      "description": "Mô tả",
      "status": "Trạng thái",
      "contentBlocksTitle": "Khối nội dung (bố cục cố định)",
      "coverImage": "Ảnh bìa",
      "coverHelper": "PNG / JPEG ≤ 5 MB",
      "file": "Tệp (PDF)",
      "fileHelper": "PDF ≤ 25 MB",
      "introduction": "Giới thiệu",
      "extraBlocks": "Khối bổ sung (đối tượng JSON) — nâng cao",
      "extraPlaceholder": "{\"chapters\": [...]}",
      "publicUrl": "URL công khai:"
    },
    "toast": {
      "saved": "Đã lưu ebook",
      "deleted": "Đã xoá",
      "errorTitle": "Lỗi"
    },
    "confirm": {
      "delete": "Xoá ebook này?"
    },
    "errors": {
      "loadFailed": "Không tải được ebooks",
      "saveFailed": "Lưu thất bại",
      "deleteFailed": "Xoá thất bại",
      "formInvalid": "Form không hợp lệ",
      "extraJsonNotObject": "extra_json phải là object JSON",
      "extraJsonInvalid": "extra_json không phải JSON hợp lệ: {{message}}"
    }
  },
  "faq": {
    "title": "FAQ",
    "description": "Quản lý câu hỏi thường gặp hiển thị dạng accordion trên homepage. Kéo-thả để sắp xếp; chỉnh sửa qua modal.",
    "status": {
      "draft": "Bản nháp",
      "published": "Đã xuất bản"
    },
    "actions": {
      "create": "Tạo FAQ mới",
      "edit": "Sửa",
      "delete": "Xóa",
      "cancel": "Hủy",
      "close": "Đóng",
      "moveUp": "Di chuyển lên",
      "moveDown": "Di chuyển xuống",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi",
      "creating": "Đang tạo…",
      "createSubmit": "Tạo FAQ"
    },
    "list": {
      "loading": "Đang tải…",
      "empty": "Chưa có FAQ nào."
    },
    "table": {
      "order": "Thứ tự",
      "question": "Câu hỏi (EN)",
      "category": "Danh mục",
      "status": "Trạng thái",
      "actions": "Hành động"
    },
    "modal": {
      "createTitle": "Tạo FAQ mới",
      "editTitle": "Sửa FAQ"
    },
    "form": {
      "question": "Câu hỏi ({{locale}})",
      "answer": "Câu trả lời ({{locale}})",
      "answerPlaceholder": "Trả lời chi tiết…",
      "category": "Danh mục",
      "categoryPlaceholder": "vd. Billing",
      "sortOrder": "Thứ tự sắp xếp",
      "status": "Trạng thái"
    },
    "confirm": {
      "delete": "Xóa FAQ này?"
    },
    "errors": {
      "generic": "Lỗi",
      "questionRequired": "Question (EN) là bắt buộc.",
      "answerRequired": "Answer (EN) là bắt buộc."
    }
  },
  "footer": {
    "title": "Footer",
    "description": "Quản lý các danh mục và mục hiển thị trên footer của trang công khai.",
    "categories": {
      "title": "Danh mục",
      "add": "+ Thêm",
      "loading": "Đang tải…",
      "empty": "Chưa có danh mục nào."
    },
    "items": {
      "title": "Mục",
      "add": "+ Thêm mục",
      "selectPrompt": "Chọn một danh mục để xem các mục.",
      "loading": "Đang tải…",
      "empty": "Chưa có mục nào."
    },
    "itemType": {
      "internal_page": "Nội bộ",
      "external_link": "Bên ngoài"
    },
    "actions": {
      "edit": "Sửa",
      "delete": "Xoá",
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…"
    },
    "category": {
      "editTitle": "Sửa danh mục",
      "addTitle": "Thêm danh mục",
      "confirmDelete": "Xoá danh mục footer này?"
    },
    "item": {
      "editTitle": "Sửa mục",
      "addTitle": "Thêm mục",
      "confirmDelete": "Xoá mục footer này?"
    },
    "form": {
      "slug": "Slug",
      "slugPlaceholder": "vd: company",
      "name": "Tên ({{locale}})",
      "description": "Mô tả ({{locale}})",
      "sortOrder": "Thứ tự sắp xếp",
      "type": "Loại",
      "typeInternal": "Trang nội bộ",
      "typeExternal": "Liên kết ngoài",
      "pageSlug": "Slug của trang",
      "pageSlugPlaceholder": "about-us",
      "fieldTitle": "Tiêu đề ({{locale}})",
      "content": "Nội dung ({{locale}})",
      "url": "URL",
      "urlPlaceholder": "https://example.com"
    },
    "toast": {
      "errorTitle": "Lỗi",
      "categorySaved": "Đã lưu danh mục",
      "itemSaved": "Đã lưu mục",
      "deleted": "Đã xoá",
      "saveFailed": "Lưu thất bại",
      "deleteFailed": "Xoá thất bại",
      "reorderFailed": "Sắp xếp lại thất bại",
      "loadCategoriesFailed": "Không tải được danh mục footer",
      "loadItemsFailed": "Không tải được mục footer"
    }
  },
  "helpCenter": {
    "breadcrumbHome": "Quản lý trang chủ",
    "breadcrumbCurrent": "Trung tâm hỗ trợ",
    "title": "Trung tâm hỗ trợ",
    "description": "Quản lý Chủ đề → Bài viết cho Trung tâm hỗ trợ (kéo-thả để sắp xếp, đa ngôn ngữ EN/VI/FR, xem trước ở tab mới).",
    "status": {
      "draft": "Bản nháp",
      "published": "Đã xuất bản"
    },
    "topics": {
      "regionLabel": "Chủ đề hỗ trợ",
      "title": "Chủ đề",
      "create": "Chủ đề mới",
      "searchLabel": "Tìm chủ đề",
      "searchPlaceholder": "Tìm theo tên…",
      "statusFilterLabel": "Lọc theo trạng thái",
      "allStatuses": "Tất cả trạng thái",
      "colDragHandle": "Tay kéo",
      "colTopic": "Chủ đề",
      "colArticles": "Bài viết",
      "colStatus": "Trạng thái",
      "colActions": "Thao tác",
      "loading": "Đang tải…",
      "empty": "Chưa có chủ đề nào. Bấm \"Chủ đề mới\" để bắt đầu.",
      "dragToReorder": "Kéo để sắp xếp lại",
      "untitled": "Chủ đề chưa đặt tên",
      "edit": "Sửa",
      "delete": "Xoá",
      "preview": "Xem trước"
    },
    "articles": {
      "regionLabel": "Bài viết",
      "selectPrompt": "Chọn một chủ đề bên trái để xem các bài viết.",
      "back": "Quay lại Chủ đề",
      "topicFallback": "Chủ đề",
      "heading": "{{name}} — Bài viết",
      "count_one": "{{count}} bài viết",
      "count_other": "{{count}} bài viết",
      "create": "Bài viết mới",
      "colDragHandle": "Tay kéo",
      "colQuestion": "Câu hỏi",
      "colStatus": "Trạng thái",
      "colSort": "Sắp xếp",
      "colActions": "Thao tác",
      "loading": "Đang tải…",
      "empty": "Chưa có bài viết nào trong chủ đề này.",
      "dragToReorder": "Kéo để sắp xếp lại",
      "untitled": "Bài viết chưa đặt tên",
      "edit": "Sửa",
      "delete": "Xoá",
      "preview": "Xem trước"
    },
    "toast": {
      "cannotDeleteTopicTitle": "Không thể xoá chủ đề",
      "cannotDeleteTopicDesc": "Chủ đề vẫn còn bài viết. Hãy xoá hoặc chuyển bài viết sang chủ đề khác trước khi xoá chủ đề.",
      "confirmDeleteTopic": "Xoá chủ đề \"{{name}}\"?",
      "topicDeleted": "Đã xoá chủ đề.",
      "confirmDeleteArticle": "Xoá bài viết \"{{name}}\"?",
      "articleDeleted": "Đã xoá bài viết.",
      "loadTopicsFailed": "Không thể tải danh sách chủ đề.",
      "loadArticlesFailed": "Không thể tải bài viết.",
      "deleteTopicFailed": "Không thể xoá chủ đề.",
      "deleteArticleFailed": "Không thể xoá bài viết.",
      "sortTopicsFailed": "Không thể sắp xếp chủ đề.",
      "sortArticlesFailed": "Không thể sắp xếp bài viết."
    }
  },
  "homepage": {
    "title": "Trang chủ",
    "description": "Quản lý nội dung trang chủ. Mỗi tab có nút lưu riêng — chỉ tab được lưu mới gửi PATCH tới server.",
    "tablistLabel": "Các tab trang chủ",
    "unsavedConfirm": "Tab hiện tại có thay đổi chưa lưu. Bạn có muốn rời khỏi tab này?",
    "unsavedDot": "Chưa lưu",
    "unsavedTitle": "Có thay đổi chưa lưu",
    "tabs": {
      "hero": "Hero",
      "best_selling": "Bán chạy nhất",
      "block1": "Khối 1",
      "block2": "Khối 2",
      "block3": "Khối 3",
      "block4": "Khối 4",
      "banner": "Banner",
      "email_popup": "Popup Email",
      "about_us": "Về chúng tôi",
      "categories": "Danh mục",
      "contact_form": "Form liên hệ",
      "faq": "FAQ",
      "static_info_2": "Thông tin tĩnh 2"
    },
    "common": {
      "saving": "Đang lưu...",
      "saveTab": "Lưu {{name}}",
      "add": "+ Thêm",
      "delete": "Xoá",
      "unsavedBadge": "Có thay đổi chưa lưu",
      "moveUp": "Di chuyển lên",
      "moveDown": "Di chuyển xuống",
      "linkUrl": "URL liên kết"
    },
    "errors": {
      "loadFailed": "Không thể tải Homepage"
    },
    "footer": {
      "label": "Lưu ý:",
      "note": "Static Info 1, Fixed Image và background của Hero được mã hoá cứng (hard-coded — developer config) theo P8.D-396 — cần PR code để chỉnh."
    },
    "readOnlyAuto": {
      "heading": "Tự động lấy",
      "bestSellingNote": "Tab này hiển thị top 5 sản phẩm bán chạy 30 ngày gần nhất, tự động cập nhật từ đơn hàng.",
      "block3Note": "Tab này hiển thị top 3 sản phẩm mới nhất, tự động cập nhật.",
      "hardCoded": "(Hard-coded — developer config)"
    },
    "block": {
      "saveError": "Không thể lưu block",
      "title": "Tiêu đề",
      "imageUrl": "URL ảnh"
    },
    "categories": {
      "saveError": "Không thể lưu Categories",
      "description": "Danh sách category/collection hiển thị trên Homepage. Dùng các nút mũi tên để sắp xếp (kéo-thả với category bundle có ở Phase 9).",
      "idPlaceholder": "ID danh mục"
    },
    "faq": {
      "saveError": "Không thể lưu FAQ",
      "description": "Chọn các FAQ đã publish (task-33) để hiện trên Homepage. Nhập FAQ ID và bấm Thêm.",
      "idPlaceholder": "ID FAQ"
    },
    "staticInfo2": {
      "saveError": "Không thể lưu Static Info 2",
      "description": "Cấu hình CTA nút Static Info 2. Background + tiêu đề là hard-coded (developer config).",
      "buttonText": "Nội dung nút ({{locale}})"
    }
  },
  "pages": {
    "title": "Trang tùy biến (Pages)",
    "descriptionBefore": "CRUD trang tĩnh tùy biến (về chúng tôi, chính sách, landing đặc biệt). URL dạng ",
    "descriptionAfter": "; slug dùng chung namespace với stories/faq/blog/help.",
    "createButton": "Tạo page mới",
    "genericError": "Lỗi",
    "loading": "Đang tải…",
    "empty": "Chưa có page nào.",
    "edit": "Sửa",
    "delete": "Xóa",
    "deleteConfirm": "Xóa page này?",
    "columns": {
      "title": "Tiêu đề",
      "slug": "Slug",
      "status": "Trạng thái",
      "updated": "Cập nhật",
      "actions": "Hành động"
    },
    "status": {
      "draft": "Nháp",
      "published": "Đã đăng"
    },
    "validation": {
      "titleRequired": "Title (EN) là bắt buộc.",
      "contentRequired": "Content (EN) là bắt buộc."
    },
    "form": {
      "ariaLabel": "Trình soạn page",
      "createTitle": "Tạo page mới",
      "editTitle": "Sửa page",
      "backLabel": "Quay lại danh sách",
      "titleLabel": "Tiêu đề ({{locale}})",
      "contentLabel": "Nội dung ({{locale}})",
      "contentPlaceholder": "Soạn nội dung trang…",
      "slugLabel": "Slug ({{locale}})",
      "slugAutoHint": " (tự động từ Tiêu đề nếu để trống)",
      "slugHint": "Phải unique cross-type với stories/faq/blog/help. BE trả 409 SLUG_TAKEN khi trùng.",
      "statusLabel": "Trạng thái",
      "seoLegend": "SEO ({{locale}})",
      "metaTitle": "Tiêu đề Meta",
      "metaDescription": "Mô tả Meta",
      "cancel": "Hủy",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi",
      "creating": "Đang tạo…",
      "create": "Tạo page"
    }
  },
  "stories": {
    "errors": {
      "generic": "Lỗi"
    },
    "list": {
      "title": "Câu chuyện thành công (Stories)",
      "description": "Hiển thị câu chuyện thành công của merchant trên trang chủ. Kéo-thả thứ tự, chỉnh sửa theo từng ngôn ngữ, xem trước bản nháp trước khi xuất bản.",
      "create": "Tạo câu chuyện mới",
      "loading": "Đang tải…",
      "empty": "Chưa có câu chuyện nào.",
      "moveUp": "Di chuyển lên",
      "moveDown": "Di chuyển xuống",
      "edit": "Sửa",
      "delete": "Xóa",
      "confirmDelete": "Xóa câu chuyện này?",
      "columns": {
        "order": "Thứ tự",
        "titleMerchant": "Tiêu đề / Merchant",
        "status": "Trạng thái",
        "created": "Ngày tạo",
        "actions": "Hành động"
      }
    },
    "status": {
      "draft": "Bản nháp",
      "published": "Đã xuất bản"
    },
    "form": {
      "editorAria": "Trình soạn câu chuyện",
      "editTitle": "Sửa câu chuyện",
      "createTitle": "Tạo câu chuyện mới",
      "back": "Quay lại danh sách",
      "preview": "Xem trước (tab mới)",
      "previewSaveFirst": "Lưu câu chuyện trước khi xem trước.",
      "cancel": "Hủy",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi",
      "creating": "Đang tạo…",
      "createSubmit": "Tạo câu chuyện",
      "errors": {
        "merchantNameRequired": "Tên merchant (EN) là bắt buộc.",
        "storyContentRequired": "Nội dung câu chuyện (EN) là bắt buộc.",
        "photoUrlRequired": "URL ảnh là bắt buộc."
      },
      "fields": {
        "photoUrl": "URL ảnh",
        "merchantName": "Tên merchant",
        "storyContent": "Nội dung câu chuyện",
        "contentPlaceholder": "Viết nội dung câu chuyện…",
        "metricsHighlight": "Chỉ số nổi bật",
        "metricsPlaceholder": "vd. \"Tăng 300% doanh thu\"",
        "quote": "Trích dẫn",
        "status": "Trạng thái",
        "slug": "Slug",
        "slugPlaceholder": "tự động từ tên merchant (EN)",
        "slugHint": "Slug dùng chung namespace giữa stories/faq/pages/blog/help.",
        "sortOrder": "Thứ tự sắp xếp"
      },
      "previewClose": "Đóng xem trước",
      "previewLabel": "Xem trước ({{locale}})",
      "previewUntitled": "Chưa có tiêu đề"
    }
  },
  "sellerSurvey": {
    "noPermission": "Bạn không có quyền truy cập trang Seller Survey. Yêu cầu permission:",
    "title": "Khảo sát Người bán",
    "description": "Khảo sát onboarding cho merchant (singleton). Tab Cấu hình quản lý câu hỏi + đối tượng nhắm; tab Kết quả xem phản hồi đã gửi và export CSV. Khảo sát hiện ở merchant onboarding Bước 2.",
    "tablistAria": "Tab khảo sát người bán",
    "tabs": {
      "config": "Cấu hình",
      "results": "Kết quả"
    },
    "loading": "Đang tải…"
  }
}
